import type { Axios, AxiosError, AxiosResponse } from 'axios'
import { ElMessage } from 'element-plus'
import { authService } from '@/services/auth.service'
import { httpClient } from '../core/http-client'

class AuthResponseInterceptor {
  activate(instance: Axios) {
    instance.interceptors.response.use(this.onFulfilled, this.onRejected)
  }

  private onFulfilled = async (config: AxiosResponse) => {
    return config
  }

  private onRejected = async (error: AxiosError) => {
    if (!error.config || !error.response) {
      ElMessage.error('Network error')
      return Promise.reject(error)
    }

    if (error.response.status === 401) {
      await authService.refresh()
      if (authService.isAuthorized) {
        return httpClient.request(error.config)
      }
      return
    }

    ElMessage.error(error)
  }
}

export const authResponseInterceptor = new AuthResponseInterceptor()
